import * as React from 'react';
import styles from './FloorButton.module.css';
import { FloorButton } from './FloorButton';
import { ReduxState } from 'ducks';
import { useSelector } from 'react-redux';
import { useMapDisplayContext } from '../MapDisplayContext';
import { isItineraryCreatorEnabled } from '../util';

export const FloorSelector: React.FC = () => {
  const { selectedFloor, setSelectedFloor } = useMapDisplayContext();

  const digitalMap = useSelector((state: ReduxState) => state.universal.digitalMap.map);

  if (!digitalMap?.map_floor_count || digitalMap.map_floor_count === 1) return null;

  const customStyle = isItineraryCreatorEnabled(digitalMap)
    ? {
        bottom: 'calc(var(--bottom-nav-height) + 100px)',
        left: '22px',
      }
    : undefined;

  return (
    <div className={styles.container} style={customStyle}>
      {Array.from({ length: digitalMap.map_floor_count }, (_, index) => index + 1)
        .reverse()
        .map((floorNumber) => (
          <FloorButton
            key={floorNumber - 1}
            selected={floorNumber === selectedFloor}
            onClick={() => setSelectedFloor(floorNumber)}
          >
            {digitalMap.display_settings.floor_labels?.length >= floorNumber
              ? digitalMap.display_settings.floor_labels[floorNumber - 1] || floorNumber
              : floorNumber}
          </FloorButton>
        ))}
    </div>
  );
};
